var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex align-end gap-xs"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"text-right"},[(_vm.$slots.default)?_vm._t("default"):_c('div',[_vm._v(_vm._s(_vm.content || ''))])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }